import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useAdminData() {
  const [overview, setOverview] = useState(null);
  const [leads, setLeads] = useState([]);
  const [scenarios, setScenarios] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const [ov, ld, sc] = await Promise.all([
          axios.get(`${API}/admin/overview`),
          axios.get(`${API}/admin/leads`),
          axios.get(`${API}/admin/scenarios`),
        ]);
        if (!active) return;
        setOverview(ov.data);
        setLeads(ld.data);
        setScenarios(sc.data);
      } catch (e) {
        if (active) toast.error("Could not load admin data");
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  return { overview, leads, scenarios, loading };
}
